export interface InvoiceSection {
  name: string;
  letters?: string;
  tag?: string;
  value?: any;
}

export interface RouteHintHop {
  pubkey: string;
  short_channel_id: string;
  fee_base_msat: number;
  fee_proportional_millionths: number;
  cltv_expiry_delta: number;
}

export interface DecodedInvoice {
  paymentRequest: string;
  sections: InvoiceSection[];
  expiry?: number;
  route_hints?: RouteHintHop[][];
}

export const AMBOSS_BASE_URL = "https://amboss.space/node/";

export const formatPubkeyForDisplay = (pubkey: string): string => {
  if (pubkey.length <= 16) return pubkey;
  return `${pubkey.slice(0, 8)}...${pubkey.slice(-8)}`;
};

export const getAmbossLink = (pubkey: string): string => {
  return `${AMBOSS_BASE_URL}${pubkey}`;
};
